import React from 'react';
import PropTypes from 'prop-types';
import {
  Badge,
  Card,
  CardContent,
  CardLayout,
  Heading,
} from '@americanexpress/dls-react';

const HotelProgramBenefits = ({ programs = [] }) => {
  if (!programs || programs.length === 0) return null;

  return (
    <section className="margin-4-t">
      <Heading level={2} variant="sans-medium-bold" className="margin-2-b">
        Programme benefits
      </Heading>
      {programs.map((program) => (
        <Card key={program.programCode} className="margin-2-b">
          <CardLayout>
            <CardContent
              title={
                <Heading level={3} variant="sans-medium-bold">
                  {program.programName}
                </Heading>
              }
            >
              {program.benefitTypes && program.benefitTypes.length > 0 && (
                <div className="flex flex-wrap margin-2-t">
                  {program.benefitTypes.map((type) => (
                    <div key={type} className="margin-1-b margin-1-r">
                      <Badge type="text" status="success">{type}</Badge>
                    </div>
                  ))}
                </div>
              )}
              {program.specialOffer && (
                <div className="margin-2-t">
                  <Heading level={4} variant="sans-medium-bold" className="margin-1-b">
                    Special offer
                  </Heading>
                  <ul className="body margin-0">
                    {program.specialOffer.offerCategory && (
                      <li>{program.specialOffer.offerCategory}</li>
                    )}
                    {program.specialOffer.minNights && (
                      <li>
                        Minimum stay:
                        {' '}
                        {program.specialOffer.minNights}
                        {' '}
                        nights
                      </li>
                    )}
                    {program.specialOffer.promotionCode && (
                      <li>
                        Promo code:
                        {' '}
                        {program.specialOffer.promotionCode}
                      </li>
                    )}
                    {program.specialOffer.cardTypes && program.specialOffer.cardTypes.length > 0 && (
                      <li>
                        Eligible cards:
                        {' '}
                        {program.specialOffer.cardTypes.join(', ')}
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </CardContent>
          </CardLayout>
        </Card>
      ))}
    </section>
  );
};

const SpecialOfferShape = PropTypes.shape({
  offerCategory: PropTypes.string,
  minNights: PropTypes.number,
  promotionCode: PropTypes.string,
  cardTypes: PropTypes.arrayOf(PropTypes.string),
});

HotelProgramBenefits.propTypes = {
  programs: PropTypes.arrayOf(PropTypes.shape({
    programCode: PropTypes.string.isRequired,
    programName: PropTypes.string.isRequired,
    benefitTypes: PropTypes.arrayOf(PropTypes.string),
    specialOffer: SpecialOfferShape,
  })),
};

export default HotelProgramBenefits;
